<template lang="pug">
.mb-S
  label(v-if="label") {{ label }}
  input(type="hidden" name="filters" :value="filter")
  .filters-holder
    .filter-holder(v-for="(filterItem, index) in filters" )
      .filter(:class="filterItem === filter ? `filter-open` : ``" @click="openDateTypeData(filterItem)")
        label.type-standard {{ defaultFiltersLabels[index] }}
      transition(name="slide")
        .filtersDateRangesHolder(v-show="filterItem === filter")
          .filtersDateRangesElements
            DateRangeSelector(
              v-show="showSelectedDateRange({filterItem: filterItem, filter: filter})"
              :showSelectedInput="showSelectedDateRange({filterItem: filterItem, filter: filter})"
              label="Date range"
              :name="`${name}-dateRange-${index}`"
              :dateRangesAllowed="filtersDateRanges[index]"
              :customDateRangeLimit="customDateRangeLimit"
              :dateRangeDisabledDates="dateRangeDisabledDates"
              :maxDate="maxDate"
              :exportNotification="exportNotification"
              @periodSelected="getPeriodSelected"
            )
</template>

<script>
import { defaultDateRanges, defaultFilters, defaultFiltersLabels } from '../helpers.js'
import DateRangeSelector from './DateRangeSelector.vue'

export default {
  name: 'DateTypeWithDateRangeSelector',
  components: { DateRangeSelector },
  props: {
    label: String,
    name: String,
    dateTypesAllowed: Object,
    maxDate: String,
    exportNotification: String,
    customDateRangeLimit: {
      default: null,
      type: Number,
    },
    dateRangeDisabledDates: {
      default: null,
      type: Array
    },
  },
  data() {
    return {
      period: '',
      filter: defaultFilters.dateOfBookingCreation,
      filters: { ...defaultFilters },
      defaultFiltersLabels: defaultFiltersLabels,
      filtersDateRanges: {
        dateOfBookingCreation: { ...defaultDateRanges },
        dateOfVisitBooking: { ...defaultDateRanges },
        dateOfPaymentCreation: { ...defaultDateRanges },
        dateOfPaymentStatus: { ...defaultDateRanges },
      },
    }
  },
  methods: {
    showSelectedDateRange(data) {
      return data.filterItem === data.filter
    },
    openDateTypeData(item) {
      if (item !== this.filter) {
        const filterKeyByValue = Object.keys(defaultFilters).find(
          key => defaultFilters[key] === item,
        )
        const dateRangeOption = Object.keys(this.filtersDateRanges[filterKeyByValue])[0]

        this.filter = item
      }
    },
    populateDateTypeFilterWithAllowedSelections() {
      const filters = this.filters
      const filtersDateRanges = this.filtersDateRanges

      Object.keys(defaultFilters).forEach(defaultFilterKey => {
        const propVal = this.dateTypesAllowed && this.dateTypesAllowed[defaultFilterKey]
        if (typeof propVal === 'undefined') {
          delete filters[defaultFilterKey]
          delete filtersDateRanges[defaultFilterKey]
        }
      })

      Object.keys(filters).forEach(filterKey => {
        Object.keys(defaultDateRanges).forEach(defaultDateRangeKey => {
          if (typeof this.dateTypesAllowed[filterKey][defaultDateRangeKey] === 'undefined') {
            delete filtersDateRanges[filterKey][defaultDateRangeKey]
          }
        })
      })

      this.filters = filters
      this.filtersDateRanges = filtersDateRanges
    },
    getPeriodSelected(period) {
      this.period = period
    },
  },
  watch: {
    period: function(newVal) {
      this.$emit('periodSelected', this.period)
    },
  },
  beforeMount() {
    this.populateDateTypeFilterWithAllowedSelections()
  },
}
</script>

<style scoped lang="stylus">
.filters-holder
  .filter
    border 1px solid #F1F3F6
    padding 10px 10px 5px 10px
    position relative
    cursor pointer

    label
      font-family Roboto
      font-style normal
      margin-left 25px
      cursor pointer

  .filter:before
    content ''
    width 17px
    height 17px
    border 1px solid #E2E2E2
    background-repeat no-repeat
    background-position center
    background-size 50%
    position absolute
    top 10px
    left 10px
    border-radius 50%

  .filter:after
    content ''
    width 17px
    height 17px
    background-image url("/images/fat-arrow-down.svg")
    background-repeat no-repeat
    background-position center
    background-size 50%
    position absolute
    top 10px
    right 10px
    border-radius 50%

  .filter-open:before
    content ''
    width 20px
    height 20px
    background #4E5A6A
    background-image url("/images/checked_white.svg")
    background-repeat no-repeat
    background-position center
    background-size 50%
    position absolute
    top 10px
    left 10px
    border-radius 50%

  .filter-open:after
    content ''
    width 20px
    height 20px
    background-image url("/images/fat-arrow-up.svg")
    background-repeat no-repeat
    background-position center
    background-size 50%
    position absolute
    top 10px
    right 10px
    border-radius 50%

  .filtersDateRangesHolder
    background #F1F3F6

    .filtersDateRangesElements
      padding 10px 35px
</style>
